export default __webpack_public_path__ + "static/media/icon_elight_tube_on_70.1171288a.png";